import { InputAddressAutocomplete } from './InputAddressAutocomplete';
import { Alert } from '../Bootstrap/Alert';

export const InputDadataAddress = {
	inheritAttrs: false,
	props: {
		defaultCity: String,
		defaultValue: String,
	},
	data: (vm) => ({
		suggestion: {
			value: vm.defaultValue,
		},
		visibleAlert: false,
	}),
	computed: {
		alertMessage: function() {
			const regexp = new RegExp(`^(г )?${this.defaultCity}([, ](.+)?)?$`);

			if (regexp.test(this.suggestion.value)) {
				return '';
			} else {
				return 'Указан неверный город';
			}
		},
	},
	render(h) {
		return (
			<div>
				<InputAddressAutocomplete
					onSelected={ (event, suggestion) => this.suggestion = suggestion }
					label="Адрес доставки"
					customValidity={ this.alertMessage }
					defaultValue={ this.defaultValue }
					attrs={ this.$attrs }
				/>
				{ this.alertMessage ? (
					<Alert type="danger" class="mt-1">
						{ this.alertMessage }
					</Alert>
				) : null }
			</div>
		);
	}
}
